import React from 'react'
import { useSelector } from 'react-redux'
import { Toast } from '@chilecompra/react-kit'
import { Root, Grid, NotificationWrapper } from './QuoteNotificationBottom.styles'

/*
 * The QuoteNotification' container.
 */
const QuoteNotificationBottom = () => {
  const { notifications, cancellationDays } = useSelector(state => state.quoteSearchHeadingFilters)

  return (
    <NotificationWrapper>
      <Root>
        {notifications > 0 && (
          <Grid container margin="32px 0" width="100%">
            <Toast
              width="100%"
              severity="primary"
              title={`Tienes ${notifications} procesos en Compra Ágil que serán cancelados en los próximos 5 días.`}
            >
              <br /> Recuerda que cuentas con {cancellationDays} días corridos desde la fecha de cierre para seleccionar
              una cotización y enviar la orden de compra, luego de este plazo la Compra Ágil será cancelada
              automáticamente.
            </Toast>
          </Grid>
        )}
      </Root>
    </NotificationWrapper>
  )
}

export default QuoteNotificationBottom
